import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { updateGHGMethodology, getGHGMethodologyById } from '../../../api/ghg';
import './edit.css';

const EditGHGMethodologyComponent: React.FC = () => {
  const { id } = useParams<{ id }>();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchGHGMethodology() {
      setLoading(true);
      try {
        const methodologyData = await getGHGMethodologyById(id);
        setLoading(false);
        form.setFieldsValue(methodologyData.response);
      } catch (error) {
        setLoading(false);
        console.error('Error fetching GHG methodology:', error);
      }
    }

    fetchGHGMethodology();
  }, [id, form]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await updateGHGMethodology(id, { name: values.display_name, ...(values.code !== undefined ? { code: values.code } : {}) });
      message.success({
        content: 'GHG methodology updated successfully',
        duration: 4,
        style: { textAlign: 'right' },
      });
      navigate('/ghg_methodologies');
    } catch (error: any) {
      console.error('Error updating GHG methodology:', error);
      message.error({
        content: error.message,
        duration: 4,
        style: { textAlign: 'right' },
      });
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo);
  };

  return (
    <div className="update-ghg-methodology-container">
      <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />} fullscreen />
      <div className="form-container">
        <h1>Update GHG Methodology</h1>
        <Form
          form={form}
          name="updateGHGMethodologyForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item
            label="Name"
            name="display_name"
            rules={[{ required: true, message: 'Please input the name of the GHG methodology!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Short Display Name"
            name="code"
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default EditGHGMethodologyComponent;
